import React, { useEffect, useState } from 'react';

function setBannerCookie(name, value, days = 1) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getBannerCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

const BirthdayOverlay = ({ dob = "0000-00-00" }) => {
    const [show, setShow] = useState(false);
    const [poppedBalloons, setPoppedBalloons] = useState({});
    const [confettiParticles, setConfettiParticles] = useState([]);

    useEffect(() => {
        const today = new Date();
        const birthDate = new Date(dob);

        const isBirthday =
            today.getDate() === birthDate.getDate() &&
            today.getMonth() === birthDate.getMonth();

        const todayKey = `bday_shown_${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

        const alreadyShown = getBannerCookie(todayKey);

        if (isBirthday && !alreadyShown) {
            setShow(true);
            setBannerCookie(todayKey, 'true', 1);

            const timer = setTimeout(() => {
                setShow(false);
            }, 20000);

            return () => clearTimeout(timer);
        }
    }, [dob]);


    const createConfettiBurst = (x, y, count = 12) => {
        const newParticles = Array.from({ length: count }, (_, i) => ({
            id: Date.now() + i,
            x,
            y,
            color: getBoldColor(),
            shape: Math.random() > 0.5 ? 'circle' : 'square',
            size: Math.random() * 6 + 3,
            velocityX: (Math.random() - 0.5) * 200,
            velocityY: (Math.random() - 0.5) * 200,
            rotation: Math.random() * 360,
        }));

        setConfettiParticles(prev => [...prev, ...newParticles]);

        setTimeout(() => {
            setConfettiParticles(prev =>
                prev.filter(p => !newParticles.find(np => np.id === p.id))
            );
        }, 1500);
    };

    const handleBalloonClick = (index, event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        const x = ((rect.left + rect.width / 2) / window.innerWidth) * 100;
        const y = ((rect.top + rect.height / 2) / window.innerHeight) * 100;

        setPoppedBalloons(prev => ({ ...prev, [index]: true }));
        createConfettiBurst(x, y, 15);

        setTimeout(() => {
            setPoppedBalloons(prev => {
                const updated = { ...prev };
                delete updated[index];
                return updated;
            });
        }, 700);
    };

    if (!show) return null;

    return (
        <div>
            <style>{`
                @keyframes floatSway {
                    0%   { transform: translate(var(--start-x), 50vh) scale(1); opacity: 1; }
                    25%  { transform: translate(calc(var(--start-x) + 15px), 25vh) scale(1.05); }
                    50%  { transform: translate(calc(var(--start-x) - 15px), 0vh) scale(1.1); }
                    75%  { transform: translate(calc(var(--start-x) + 10px), -50vh) scale(1.05); }
                    100% { transform: translate(calc(var(--start-x) - 10px), -120vh) scale(1.1); opacity: 0.8; }
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: scale(0.9); }
                    to { opacity: 1; transform: scale(1); }
                }
                @keyframes pop {
                    0% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.8); opacity: 0.9; }
                    100% { transform: scale(0); opacity: 0; }
                }
                @keyframes confettifall {
                    0% { transform: translateY(0) translateX(0) rotate(0deg); opacity: 1; }
                    100% { transform: translateY(300px) translateX(var(--drift)) rotate(var(--rotation)); opacity: 0; }
                }
                @keyframes stringWiggle {
                    0%, 100% { transform: translateX(-50%) rotate(0deg); }
                    50% { transform: translateX(-50%) rotate(3deg); }
                }
                @keyframes shine {
                    0% { background-position: -150px 0; }
                    50% { background-position: 150px 0; }
                    100% { background-position: -150px 0; }
                }
                .confetti-particle {
                    position: absolute;
                    pointer-events: none;
                    animation: confettifall 1.5s ease-out forwards;
                    --drift: var(--velocity-x);
                    --rotation: var(--end-rotation);
                }
                .balloon-string {
                    animation: stringWiggle 1s ease-in-out infinite;
                }
                .shiny-balloon {
                    background-size: 200px 200px;
                    animation: shine 3s linear infinite;
                    box-shadow: inset -5px -10px 15px rgba(0,0,0,0.25),
                                inset 5px 5px 15px rgba(255,255,255,0.4),
                                0 8px 15px rgba(0,0,0,0.25);
                }
            `}</style>

            <div style={styles.canvas}>
                {confettiParticles.map((particle) => (
                    <div
                        key={particle.id}
                        className="confetti-particle"
                        style={{
                            left: `${particle.x}%`,
                            top: `${particle.y}%`,
                            width: `${particle.size}px`,
                            height: `${particle.size}px`,
                            backgroundColor: particle.color,
                            borderRadius: particle.shape === 'circle' ? '50%' : '0%',
                            '--velocity-x': `${particle.velocityX}px`,
                            '--end-rotation': `${particle.rotation + 360}deg`,
                        }}
                    />
                ))}

                <div style={styles.balloonsWrapper}>
                    {Array.from({ length: 25 }).map((_, idx) => {
                        const popped = poppedBalloons[idx];
                        const color = getShinyGradient();
                        const width = 25 + Math.random() * 20;
                        const height = width * (1.3 + Math.random() * 0.5);
                        const borderRadius = `${Math.random() * 50 + 40}%`;
                        const startX = `${Math.random() * 100}vw`;
                        const duration = 8 + Math.random() * 5;

                        return (
                            <div
                                key={idx}
                                onClick={(e) => handleBalloonClick(idx, e)}
                                className={!popped ? 'shiny-balloon' : ''}
                                style={{
                                    ...styles.balloon,
                                    width: `${width}px`,
                                    height: `${height}px`,
                                    borderRadius,
                                    '--start-x': startX,
                                    background: popped ? 'transparent' : color,
                                    animation: popped
                                        ? 'pop 0.5s ease-out forwards'
                                        : `floatSway ${duration}s ease-in-out infinite`,
                                    animationDelay: `${Math.random() * 5}s`,
                                }}
                            >
                                {popped && <div style={styles.firecracker}>💥</div>}
                                {!popped && (
                                    <div
                                        className="balloon-string"
                                        style={{
                                            position: 'absolute',
                                            bottom: '-30px',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            width: '2px',
                                            height: '30px',
                                            background: `linear-gradient(to bottom, #999, #555)`,
                                            opacity: 0.8,
                                        }}
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

const styles = {
    canvas: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        animation: 'fadeIn 1s ease-out',
    },
    balloonsWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        zIndex: 1,
    },
    balloon: {
        position: 'absolute',
        bottom: '-80px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
    firecracker: {
        fontSize: '24px',
        animation: 'pop 0.7s ease-out forwards',
    },
};

function getBoldColor() {
    const colors = [
        "#FF4C4C", "#FF9900", "#FFD700",
        "#00BFFF", "#32CD32", "#9932CC", "#FF1493"
    ];
    return colors[Math.floor(Math.random() * colors.length)];
}

function getShinyGradient() {
    const base = getBoldColor();
    return `radial-gradient(circle at 30% 30%, 
        rgba(255,255,255,0.85) 0%, 
        ${base} 70%, 
        ${base} 100%)`;
}

export default BirthdayOverlay;



// WEBPACK FOOTER //
// ./src/components/BirthdayOverlay.js